import React from 'react';
export const useEffectOnTrueLogPaywall = (isTrue, paywall) => React.useEffect(() => {
  if (isTrue && (paywall === null || paywall === void 0 ? void 0 : paywall.logger)) {
    paywall.logger();
  }
}, [isTrue]);